// extracted by mini-css-extract-plugin
module.exports = {"card":"customPages_card__1TKZ2","draggable":"customPages_draggable__dNt7w"};